/**
 * Transforms a storybook.internal.scale.com url to a dashboard.scale.com/corp-api. This allows access to files in s3://storybook for corp users.
 *
 * This transform should only be run in the context of corp-storybook (e.g. dashboard.scale.com/corp-api/storybook/b-master), not internal-storybook.
 * This allows all corp users to access internal assets even if they don't have direct access to the internal scale network, which typically requires engineer-level access.
 *
 * Sample:
 * > maybeReplaceInternalUrlsWithCorp('https://assets.storybook.internal.scale.com/scenes/imageannotation/default.json')
 * 'https://dashboard.scale.com/corp-api/storybook/assets/scenes/imageannotation/default.json'
 *
 */
export function maybeReplaceInternalUrlsWithCorp(urlOrJsonString: string) {
  const isCorpStorybook = window.location.hostname === 'dashboard.scale.com';
  if (!isCorpStorybook) return urlOrJsonString;
  return urlOrJsonString.replaceAll(
    'https://assets.storybook.internal.scale.com/',
    'https://dashboard.scale.com/corp-api/storybook/assets/',
  );
}
